import { queryStringify, STORAGE_EVENT } from '@utils'
import { createMutationHelper, createRequestHelper, createStorageProvider } from '@utils/swr'
import { type ECommerceProductsRequest } from '../types/apiRequest'
import { type ECommerceProductsResponse } from '../types/apiResponse'
import { type ECommerceApis } from '../types/apis'

const provider = createStorageProvider('ec-products', STORAGE_EVENT.sessionStorage)

const {
  useRequest,
} = createRequestHelper<ECommerceApis['get']['products'], ECommerceProductsResponse, ECommerceProductsRequest>({
  client: 'eCommerce',
  key: (params) => {
    if (!params) return null
    const { country_code, project_code, product_ids, subship_product_ids } = params
    if (!product_ids && !subship_product_ids) return null
    if (!country_code || !project_code) {
      console.warn('[useApiECommerceProducts] country_code, project_code are required!')
      return null
    }
    return `/products?${queryStringify({
      country_code,
      project_code,
      product_ids,
      subship_product_ids: subship_product_ids === '0' ? undefined : subship_product_ids,
    }, {
      skipEmptyString: true,
      skipNull: true,
    })}`
  },
  provider,
})

export const useApiECommerceProducts = useRequest

const {
  useMutation,
} = createMutationHelper<ECommerceApis['get']['products'], ECommerceProductsResponse, ECommerceProductsRequest>({
  client: 'eCommerce',
  key: '/products',
  fetcher: (_, { client, arg }) => client.get(`/products?${queryStringify(arg)}`),
})

export const useApiMutationECommerceProducts = useMutation
